import { styled } from 'styled-components';
import { Media } from '../../../theme/Media.js';
/*
  Component used to separate form lines with margins
*/
const FormItem = styled.div `
  &:not(:last-child) {
    margin-bottom: 24px;
  }

  @media ${Media.xsMax} {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;
export default FormItem;
